module.exports = __webpack_public_path__ + "static/media/Computer Science.f2e3d255.png";